import React from "react";
import { sanitizeEmail } from "../../utils/sanitization";

export const CenterFormFields = ({ center, onChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Center Name
        </label>
        <input
          type="text"
          value={center.centerName}
          onChange={(e) => onChange({ ...center, centerName: e.target.value })}
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />
      </div>

      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Address
        </label>
        <input
          type="text"
          value={center.formattedAddress}
          onChange={(e) =>
            onChange({ ...center, formattedAddress: e.target.value })
          }
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />
      </div>

      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Phone
        </label>
        <input
          type="tel"
          value={center.phone}
          onChange={(e) => onChange({ ...center, phone: e.target.value })}
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />
      </div>

      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Email
        </label>
        <input
          type="email"
          value={center.email}
          onChange={(e) =>
            onChange({ ...center, email: sanitizeEmail(e.target.value) })
          }
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />
      </div>

      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Website
        </label>
        <input
          type="url"
          value={center.website}
          onChange={(e) => onChange({ ...center, website: e.target.value })}
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />
      </div>
    </div>
  );
};
